import { render } from "./ModalNoCorresponde.vue?vue&type=template&id=6cbc1ad0&scoped=true"
import script from "./ModalNoCorresponde.vue?vue&type=script&lang=js"
export * from "./ModalNoCorresponde.vue?vue&type=script&lang=js"

import "./ModalNoCorresponde.vue?vue&type=style&index=0&id=6cbc1ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbc1ad0"]])

export default __exports__